import { SurchargesOptimizationsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

export const INIT_STATE = {
    loadingSurchargesNoSurcharges: false,
    loadingNoNonShipmentSurcharges: false,
    loadingNonShipmentSurchargesCost: false,
    loadingSurchargesCost: false,
    loadingAuditableSurchargesCost: false,
    loadingComparisonSurchargesCost: false,
    loadingSurchargesComparisonRecords: false,
    errorSurchargesNoSurcharges: null,
    errorNoNonShipmentSurcharges: null,
    errorNonShipmentSurchargesCost: null,
    errorSurchargesCost: null,
    errorAuditableSurchargesCost: null,
    errorComparisonSurchargesCost: null,
    errorSurchargesComparisonRecords: null,
    surchargesNoSurcharges: null,
    noNonShipmentSurcharges: null,
    nonShipmentSurchargesCost: null,
    surchargesCost: null,
    auditableSurchargesCost: null,
    comparisonSurchargesCost: null,
    surchargesComparisonRecords: null,
    surchargesComparisonRecordsPagination: PAGINATION_DEFAULT_VALUE,
};

type SurchargesOptimizationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loadingSurchargesNoSurcharges: Boolean,
    loadingNoNonShipmentSurcharges: Boolean,
    loadingNonShipmentSurchargesCost: Boolean,
    loadingSurchargesCost: Boolean,
    loadingAuditableSurchargesCost: Boolean,
    loadingComparisonSurchargesCost: Boolean,
    loadingSurchargesComparisonRecords: Boolean,
    errorSurchargesNoSurcharges: null,
    errorNoNonShipmentSurcharges: null,
    errorNonShipmentSurchargesCost: null,
    errorSurchargesCost: null,
    errorAuditableSurchargesCost: null,
    errorComparisonSurchargesCost: null,
    errorSurchargesComparisonRecords: null,
    surchargesNoSurcharges: any,
    noNonShipmentSurcharges: any,
    nonShipmentSurchargesCost: any,
    surchargesCost: any,
    auditableSurchargesCost: any,
    comparisonSurchargesCost: any,
    surchargesComparisonRecords: any,
    surchargesComparisonRecordsPagination: any,
};

const SurchargesOptimizations = (state: State = INIT_STATE, action: SurchargesOptimizationsAction): any => {
    switch (action.type) {
        case SurchargesOptimizationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES: {
                    return {
                        ...state,
                        loadingSurchargesNoSurcharges: false,
                        surchargesNoSurcharges: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST: {
                    return {
                        ...state,
                        loadingSurchargesCost: false,
                        surchargesCost: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST: {
                    return {
                        ...state,
                        loadingAuditableSurchargesCost: false,
                        auditableSurchargesCost: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES: {
                    return {
                        ...state,
                        loadingNoNonShipmentSurcharges: false,
                        noNonShipmentSurcharges: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST: {
                    return {
                        ...state,
                        loadingNonShipmentSurchargesCost: false,
                        nonShipmentSurchargesCost: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST: {
                    return {
                        ...state,
                        loadingComparisonSurchargesCost: false,
                        comparisonSurchargesCost: action.payload.data
                    };
                }
                case SurchargesOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS: {
                    return {
                        ...state,
                        loadingSurchargesComparisonRecords: false,
                        surchargesComparisonRecords: action.payload.data.surchargesComparisonRecords,
                        surchargesComparisonRecordsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                default:
                    return { ...state, loadingSurchargesNoSurcharges: false, loadingSurchargesCost: false, loadingAuditableSurchargesCost: false, loadingComparisonSurchargesCost: false, loadingNoNonShipmentSurcharges: false, loadingNonShipmentSurchargesCost: false };
            }

        case SurchargesOptimizationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES: {
                    return { ...state, loadingSurchargesNoSurcharges: false, errorSurchargesNoSurcharges: action.payload.error };
                }
                case SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST: {
                    return { ...state, loadingSurchargesCost: false, errorSurchargesCost: action.payload.error };
                }
                case SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST: {
                    return { ...state, loadingAuditableSurchargesCost: false, errorAuditableSurchargesCost: action.payload.error };
                }
                case SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES: {
                    return { ...state, loadingNoNonShipmentSurcharges: false, errorNoNonShipmentSurcharges: action.payload.error };
                }
                case SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST: {
                    return { ...state, loadingNonShipmentSurchargesCost: false, errorNonShipmentSurchargesCost: action.payload.error };
                }
                case SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST: {
                    return { ...state, loadingComparisonSurchargesCost: false, errorComparisonSurchargesCost: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES:
            return { ...state, loadingSurchargesNoSurcharges: true, surchargesNoSurcharges: null };
        case SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES:
            return { ...state, loadingNoNonShipmentSurcharges: true, noNonShipmentSurcharges: null };
        case SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST:
            return { ...state, loadingNonShipmentSurchargesCost: true, nonShipmentSurchargesCost: null };
        case SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST:
            return { ...state, loadingSurchargesCost: true, surchargesCost: null };
        case SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST:
            return { ...state, loadingAuditableSurchargesCost: true, auditableSurchargesCost: null };
        case SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST:
            return { ...state, loadingComparisonSurchargesCost: true, comparisonSurchargesCost: null };
        default:
            return { ...state };
    }
};

export default SurchargesOptimizations;
